import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/suppliers/$supplierId',
}).lazy(() => import('./$supplierId.index.lazy').then((d) => d.Route))
